import { useEffect, useState } from 'react';
import { UseQueryResult } from 'react-query';
import { ActualNotifications } from 'src/components/moleculesLegacy/ActualNotifications';
import { NotificationsQuery } from 'src/graphql/generated';
import { useNotificationManagement } from 'src/hooks';
import { NavbarVariantEnum } from 'src/types';
import { NotificationState } from '../../../api';
import {
  NotificationDrawerStyled,
  StyledPageCover,
} from './NotificationsDrawer.styled';

export const NotificationsDrawer = ({
  isOpen,
  notifications,
  setIsOpen,
  navOpen,
  variant,
  organisation,
  atlasVariant,
}: {
  isOpen: boolean;
  notifications: UseQueryResult<NotificationsQuery, unknown>;
  setIsOpen: (boolean: boolean) => void;
  navOpen: boolean;
  variant: NavbarVariantEnum;
  organisation?: string;
  atlasVariant?: boolean;
}) => {
  const defaultNumberOfNotificationsToShow = 20;
  const unreadNotifications = notifications.data?.notifications.filter(
    (notification) => notification.state === NotificationState.CREATED,
  );
  const [numberOfNotificationsToShow, setNumberOfNotificationsToShow] =
    useState(defaultNumberOfNotificationsToShow);

  const {
    clearAll,
    handleNotificationRead,
    handleNotificationClose,
    updateNotificationStatuses,
  } = useNotificationManagement({ notifications, setIsOpen });

  useEffect(() => {
    if (isOpen && unreadNotifications?.length) {
      const ids = unreadNotifications.map((notification) => notification.id);
      updateNotificationStatuses(ids, NotificationState.READ);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  return (
    <>
      <StyledPageCover
        onClick={() => setIsOpen(false)}
        isOpen={isOpen}
        navOpen={navOpen}
        atlasVariant={atlasVariant}
      />

      <NotificationDrawerStyled
        isOpen={isOpen}
        navOpen={navOpen}
        variant={variant}
        atlasVariant={atlasVariant}
      >
        <ActualNotifications
          notificationsOpen={isOpen}
          notifications={notifications.data?.notifications || []}
          handleMenuClose={() => setIsOpen(false)}
          handleNotificationClose={handleNotificationClose}
          handleNotificationRead={handleNotificationRead}
          numberOfNotificationsToShow={numberOfNotificationsToShow}
          showMore={() =>
            setNumberOfNotificationsToShow(numberOfNotificationsToShow + 20)
          }
          newNavEnabled
          clearAll={clearAll}
          variant={variant}
          organisation={organisation}
        />
      </NotificationDrawerStyled>
    </>
  );
};
